import API from "@/service/Index";
import { Action, Module, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Finance extends VuexModule {
  @Action
  DoGetBankAccountCacheById(bankAccountIdList: Array<number>) {
    return new Promise((resolve, reject) => {
      API.FinanceService.DoGetBankAccountViewDetail(bankAccountIdList).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          resolve(res.data.list);
        } else {
          resolve([]);
        }
      });
    });
  }
}
